import { Type } from "@sinclair/typebox";
import { NonEmptyString } from "./primitives.js";
import { SessionPreviewInfoSchema } from "./session-preview.js";

export const SessionEnvironmentExplainParamsSchema = Type.Object(
  {
    sessionKey: NonEmptyString,
    publicOrigin: Type.Optional(Type.String()),
  },
  { additionalProperties: false },
);

export const SessionEnvironmentExplainResultSchema = Type.Object(
  {
    sessionKey: NonEmptyString,
    agentId: NonEmptyString,
    sandboxed: Type.Boolean(),
    mode: Type.Union([Type.Literal("off"), Type.Literal("non-main"), Type.Literal("all")]),
    scope: Type.Union([Type.Literal("session"), Type.Literal("agent"), Type.Literal("shared")]),
    mainSessionKey: Type.String(),
    workspaceDir: NonEmptyString,
    workspaceScope: Type.Union([Type.Literal("sandbox"), Type.Literal("session")]),
    workspaceIsolated: Type.Boolean(),
    containerName: Type.Union([Type.String(), Type.Null()]),
    containerExists: Type.Boolean(),
    containerRunning: Type.Boolean(),
    containerLastUsedAtMs: Type.Union([Type.Integer({ minimum: 0 }), Type.Null()]),
    image: Type.String(),
    network: Type.String(),
    dockerReachable: Type.Boolean(),
    toolPolicyAllow: Type.Array(Type.String()),
    toolPolicyDeny: Type.Array(Type.String()),
    hostWarning: Type.Union([Type.String(), Type.Null()]),
    // JAISIU-3122: optional `host` block for the empty-chat environment
    // panel. Older gateways omit it; newer ones include the full shape.
    host: Type.Optional(Type.Any()),
    preview: SessionPreviewInfoSchema,
  },
  { additionalProperties: false },
);

export const SessionEnvironmentRecreateParamsSchema = Type.Object(
  {
    sessionKey: NonEmptyString,
    removeWorkspace: Type.Optional(Type.Boolean()),
  },
  { additionalProperties: false },
);

export const SessionEnvironmentRecreateResultSchema = Type.Object(
  {
    sessionKey: NonEmptyString,
    removedContainers: Type.Array(Type.String()),
    removedWorkspaceDirs: Type.Array(Type.String()),
    errors: Type.Array(Type.String()),
  },
  { additionalProperties: false },
);
